import { render } from "./WebContent.vue?vue&type=template&id=70f77a44&scoped=true"
import script from "./WebContent.vue?vue&type=script&lang=js"
export * from "./WebContent.vue?vue&type=script&lang=js"

import "./WebContent.vue?vue&type=style&index=0&id=70f77a44&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f77a44"]])

export default __exports__